export function toShortID (evID) {
    return evID.indexOf('_') === -1 ? evID : evID.split('_')[1];
}

export function toLongID (clientID, evID) {
    return clientID + '_' + evID;
}
